import styled from "styled-components";

export const Table = styled.table`
  width: 98%;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
  max-width: 1120px;
  margin: 20px auto;
`;
export const Thead = styled.thead`
  border-collapse: collapse;
`;

export const Tbody = styled.tbody``;
export const Tr = styled.tr``;
export const Th = styled.th`
  border-collapse: collapse;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  text-align: ${(props) => (props.width ? props.width + "%" : "auto")};
`;
